import type { CurrentUserResponse } from "./types";

export function hasPermission(user: CurrentUserResponse | undefined, permission: string): boolean {
  return user?.permissions?.includes(permission) ?? false;
}

/** Keep this aligned with the backend ROLE_ADMIN guard. */
export function isAdmin(user: CurrentUserResponse | undefined): boolean {
  return user?.roles?.includes("ADMIN") ?? false;
}
